import { AllMeasures, Measure, Unit } from '../types'
import Big from 'big.js'

// important: this function has no guarantee that the measure is valid
export const getMeasureFromUrl = (allMeasures: AllMeasures, measureUrl: string): Measure => {
  return Object.values(allMeasures).find(m => m.url === measureUrl) as Measure
}

export const isValidMeasureUrl = (allMeasures: AllMeasures, measureUrl: string | undefined): boolean => {
  if (measureUrl === undefined) {
    return false
  }
  const measureObject: Measure = getMeasureFromUrl(allMeasures, measureUrl)
  if (measureObject === undefined || measureObject === null) {
    return false
  }
  return true
}

export const isValidUnitToUnitURLForMeasure = (allMeasures: AllMeasures, measureUrl: string, fromUnitUrl: string, toUnitUrl: string | undefined): boolean => {
  if (measureUrl === undefined || fromUnitUrl === undefined || toUnitUrl === undefined) {
    return false
  }
  if (fromUnitUrl === toUnitUrl) {
    return false
  }

  const measureObject: Measure = getMeasureFromUrl(allMeasures, measureUrl)
  if (measureObject === undefined || measureObject === null) {
    return false
  }

  const thisMeasureUnitURLs: string[] = Object.values(measureObject.units).map(unit => unit.url)
  return thisMeasureUnitURLs.includes(fromUnitUrl) && thisMeasureUnitURLs.includes((toUnitUrl))
}

export const getUnitObjectFromUnitURLForMeasure = (measure: Measure, unitURL: string): Unit => {
  // @ts-expect-error
  return Object.values(measure.units).find(u => u.url === unitURL)
}

export const getUnitObjectFromUnitLabelForMeasure = (measure: Measure, unitName: string): Unit => {
  // @ts-expect-error
  return Object.values(measure.units).find(u => u.displayName === unitName)
}


// todo: later on implement locale here in order to use . or , as decimal separator based on the country
const addCommas = (numberString: string): string => {
  const parts = numberString.split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}

export const formatConversionValueForReadability = (valueToFormat: string): string => {
  try {
    return addCommas(new Big(valueToFormat).toFixed())
  } catch (e) {
    console.log(e)
    return '\u00A0' // non-breaking space
  }
}


export const createUnitLabel = (option: Unit): string => {
  return option.symbol
    ? `${option.displayName} (${option.symbol})`
    : option.displayName
}
